import { useRef, useEffect, RefObject } from 'react'
import useEventListener from '../useEventListener'

const useOutsideClick = <T extends Element>(
  ref: RefObject<T>,
  onClickOutside: (t: Element) => void,
) => {
  const handlerRef = useRef(onClickOutside)

  useEffect(() => {
    handlerRef.current = onClickOutside
  }, [onClickOutside])

  const onDocumentClick = ({ target }: Event) => {
    if (!ref.current || ref.current.contains(target as Node)) return
    handlerRef.current(target as Element)
  }

  const eventType = document.ontouchstart !== null ? 'mousedown' : 'touchstart'

  useEventListener(eventType, onDocumentClick, document.body)
}

export default useOutsideClick
